module.exports = __webpack_public_path__ + "img/boulder_creek.71253be4.jpg";